// extracted by mini-css-extract-plugin
module.exports = {"plug-and-play-125w":"PlugAndPlay_plug-and-play-125w__kwE_d"};